The conflict result for the `createCandidateProcessHistoryItem` mutation.
